import type * as BasketUpdated from '@ori-events/basket-updated';
import type * as ReplaceSubscriptionFailed from '@ori-events/replace-subscription-failed';

export type ReplaceSubscriptionResponse = BasketUpdated.Data | ReplaceSubscriptionFailed.Data;

export const isReplaceSubscriptionErrorResponse = (
  response: ReplaceSubscriptionResponse,
): response is ReplaceSubscriptionFailed.Data => 'isSuccess' in response && !response.isSuccess;
